import { useEffect } from "react";
import "./App.css";
import "./i18n"; // Importar configuración i18n
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Home from "./components/Home";
import WhenIWakeLanding from "./components/WhenIWakeLanding";
import UplightLanding from "./components/UplightLanding";
import AfternoonLanding from "./components/AfternoonLanding";
import SpotifyLanding from "./components/SpotifyLanding";
import FloatingInTimeLanding from "./components/FloatingInTimeLanding";
import ShadesLanding from "./components/ShadesLanding";
import InsaneLanding from "./components/InsaneLanding";
import ItsOverLanding from "./components/ItsOverLanding";
import OdysseyLanding from "./components/OdysseyLanding";
import PlaylistLanding from "./components/PlaylistLanding";
import AdminPanel from "./components/AdminPanel";
import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <HelmetProvider>
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/playlist" element={<PlaylistLanding />} />
          <Route path="/uplight" element={<UplightLanding />} />
          <Route path="/afternoon-with-myself" element={<AfternoonLanding />} />
          <Route path="/listen/:trackSlug" element={<SpotifyLanding />} />
          <Route path="/when-i-wake" element={<WhenIWakeLanding />} />
          <Route path="/floating-in-time" element={<FloatingInTimeLanding />} />
          <Route path="/shades" element={<ShadesLanding />} />
          <Route path="/insane" element={<InsaneLanding />} />
          <Route path="/its-over" element={<ItsOverLanding />} />
          <Route path="/odyssey" element={<OdysseyLanding />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
      <AdminPanel />
    </div>
    </HelmetProvider>
  );
}

export default App;